import { render, staticRenderFns } from "./button-disable-account.vue?vue&type=template&id=123d4948&"
import script from "./button-disable-account.vue?vue&type=script&lang=js&"
export * from "./button-disable-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports